import React from 'react';
import Route from 'react-router/lib/Route';
import { getRouteComponentProp } from 'common/src/app/util/routeCallback';
import Pages from 'common/src/app/data/enum/Pages';
import WhatCanIEat from 'bundle-loader?lazy&reactHot&name=WhatCanIEat!./index';

const routes = (
  <Route
    path={Pages.UK_PUBLIC_WHAT_CAN_I_EAT}
    {...getRouteComponentProp(WhatCanIEat)}
    title="Welcome to Food Optimising| Slimming World"
    description="With Slimming World’s filling, flexible Food Optimising plan, you can lose weight enjoying food you love. Discover what to eat for weight loss that lasts"
  />
);

export default routes;
